import ShowWhatYouLearned from './ShowWhatYouLearned';
import Question1 from './Question1';
import Question2 from './Question2';
import Question3 from './Question3';
import Question4 from './Question4';
import Question5 from './Question5';

export default {
  title: 'Challenge',
  children: [
    ShowWhatYouLearned,
    Question1,
    Question2,
    Question3,
    Question4,
    Question5
  ]
};



// WEBPACK FOOTER //
// ./src/data/challenge/index.js